import Axios from 'axios';

export const userLocationDetails = async () => {
  const apiConfigs = [
    { url: 'https://api.ipstack.com/check?', key: 'a57c3b432c63ba06c479e51648822467', transform: transformIpstackResponse },
    { url: 'https://ipinfo.io/json?', key: '92a68ebdcb989b', transform: transformIpinfoResponse },
    { url: 'https://ipinfo.io/json?', key: 'e99a59ce05dc82', transform: transformIpinfoResponse },
  ];

  for (const { url, key, transform } of apiConfigs) {
    try {
      const apiResult = await Axios.get(`${url}${url.includes('ipstack') ? 'access_key' : 'token'}=${key}`);
      return transform(apiResult.data);
    } catch (error) {
      console.error('error fetching location');
    }
  }

  console.error('Failed fetch location');
  return {};
};

const transformIpstackResponse = (result) => ({
  city: result.city,
  country: result.country_code,
  countryName: result.country_name,
  continentCode: result.continent_code,
  continentName: result.continent_name,
  ip: result.ip,
  loc: result.latitude + ',' + result.latitude,
  org: result.connection.isp,
  postal: result.zip,
  region: result.region_name,
  regionCode: result.region_code,
  timezone: result.time_zone,
  currency: result.currency,
  dialCode: result.location.calling_code,
});

const transformIpinfoResponse = (result) => result;
